define('entities/kitc',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var Kitc = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/kitcs/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      ctrlType: 'POS'
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function (kitSecId) {
      return Settings.url('compuzz', 'v2/kits/' + kitSecId + '/kitcs');
    },

    save: function() {
      this.url = this.postUrl(this.get('refKit').secId);
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var KitcCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/kits/');
    },
    model: Kitc
  });

  var API = {

    getKitcCollectionUrl: function(kitSecId) {
      new KitcCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/kits/' + kitSecId + '/kitcs', params);
    },

    getAllKitc: function(kitSecId, params) {
      var url = Settings.url('compuzz', 'v2/kits' + kitSecId + '/kitcs', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getKitcCountUrl: function(kitSecId) {
      var params = '';
      return 'v2/kits/'+kitSecId+'/kitcs/rowCount' + params;
    },

    deleteKitc: function(kitSecId, secId){
      var url = Settings.url('compuzz', 'v2/kits/'+kitSecId+'/kitcs/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('kitc:get-collection-url', function(kitSecId) {
      return API.getKitcCollectionUrl(kitSecId);
  });

  App.reqres.setHandler('kitc:get-collection-to-page', function(kitSecId, params) {
      return API.getAllKitc(kitSecId, params);
  });

  App.reqres.setHandler('kitc:get-count-url', function(kitSecId) {
    return API.getKitcCountUrl(kitSecId);
  });

  App.reqres.setHandler('kitc:model', function(itemJSON) {
    return new Kitc(itemJSON);
  });

  App.reqres.setHandler('kitc:delete', function(kitSecId, secId) {
    return API.deleteKitc(kitSecId, secId);
  });
});
